import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';

import { AuthService } from '../core/auth.service';
import { ServiceBase } from '../shared/base/service-base';

import { Notification } from './notification';

@Injectable()
export class NotificationService extends ServiceBase<Notification>  {
  constructor(db: AngularFireDatabase,  private auth: AuthService) {
    super(db, '/notifications');
  }

  push(value: Notification) {
    return super.push(Object.assign(new Notification(), {
      timestamp: this.timestamp,
      user: this.auth.auth.uid
    }, value));
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/notifications/notification.service.ts